export function urlWithParams(path, params) {
    const url = new URL('http://example.com' + path);
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined) {
        url.searchParams.append(key, params[key]);
      }
    });
    return url.pathname + url.search;
}



// WEBPACK FOOTER //
// ./utils/http.js